import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/icons/facebook.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/icons/Linkedin.png");
;
import(/* webpackMode: "eager", webpackExports: ["FathomAnalytics"] */ "/opt/build/repo/src/app/fathom.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/Header.js");
